import { useQueries } from 'react-query';
import axiosInstance from './axiosInstance';
import { useAuthContext } from '../contexts/AuthContext';

const useMultipleFetch = (multipleQueries) => {
    const { checkToken } = useAuthContext();
    
    const fetchData = async (props) => {
        // verificar e dar refresh ao token se necessário
        const tokenIsValid = await checkToken();
        if (!tokenIsValid) {
            console.error("Token validation failed for endpoint:", props.path);
            throw new Error("Authentication failed - token is invalid or expired");
        }
        
        return axiosInstance('GET', props.path, props.params, 'application/json', multipleQueries.baseUrl);
    };
    
    return useQueries(
        multipleQueries.map((element, index) => { 
            return {
                queryKey: ['post', element.id], 
                queryFn: () => fetchData(element),
                retry: false,
            };
        })
    );
};

export default useMultipleFetch;